import { useState, useEffect } from 'react';
import { getLocationService } from '../services/locationServiceInstance';

/**
 * Hook que resuelve el nombre en español de un país a partir de su código ISO2,
 * usando la fuente unificada de CSC (LocationService).
 * Retorna el nombre en español, o el código ISO2 como fallback.
 */
export function useNombrePais(iso2: string | undefined | null): { nombre: string; loading: boolean } {
  const [nombre, setNombre] = useState<string>(iso2 || '');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!iso2) {
      setNombre('');
      return;
    }

    let cancelled = false;
    setLoading(true);

    getLocationService().getCountries()
      .then(countries => {
        if (cancelled) return;
        const pais = countries.find(c => c.iso2 === iso2);
        setNombre(pais?.nombre_es || iso2);
      })
      .catch(() => {
        if (!cancelled) setNombre(iso2);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [iso2]);

  return { nombre, loading };
}
